export default function VLOOKUP() {
  return (
    <div className="p-4">
      <h1>VLOOKUP</h1>
    </div>
  );
}
